const NAMESPACE = "EDIT_USER";
const actionType = type => `${NAMESPACE}_${type}`;

export const editUserConstants = {
	LOAD_HIERARCHY_REQUEST: actionType("LOAD_HIERARCHY_REQUEST"),
	LOAD_HIERARCHY_SUCCESS: actionType("LOAD_HIERARCHY_SUCCESS"),
	LOAD_HIERARCHY_FAILURE: actionType("LOAD_HIERARCHY_FAILURE"),
};
